import ForumIcon from '@mui/icons-material/Forum';
import { EventMessengerWidget, useProduct } from '@revenuewell/front-end-bundle';
import {
  LocationSwitchEventData,
  SwitchLocationDialog
} from 'apps/wrapper/src/components/shared/dialog/switch-location-dialog/switch-location-dialog';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { useLocations } from 'apps/wrapper/src/hooks/use-locations';
import { IContactProfile } from 'apps/wrapper/src/services/api-client/interface';
import { EventJumpToMessage } from 'apps/wrapper/src/types/event-bus';
import { FC, useCallback, useState } from 'react';
import { IconButtonStyled } from '../contact-actions.styles';

export interface MessengerActionProps {
  contact: IContactProfile;
  onClick?: () => void;
}

export const MessengerAction: FC<MessengerActionProps> = (props) => {
  const { contact, onClick } = props;
  const { hasProduct } = useProduct();
  const { publish } = useEventBus();
  const { selectedLocation, locations, switchLocation } = useLocations();
  const [locationSwitchEvent, setLocationSwitchEvent] = useState<LocationSwitchEventData | null>(null);

  const isCellPhoneValid = useCallback(() => {
    return contact.cellPhone && contact.cellPhone.length > 0;
  }, [contact]);

  const handleMessengerClick = () => {
    if (!selectedLocation || !contact) return;

    if (contact.location.id != selectedLocation.id) {
      const location = locations.find((l) => l.id === contact.location.id);

      if (!location || !contact.cellPhone) return;

      setLocationSwitchEvent({
        patientName: `${contact.firstName} ${contact.lastName}`,
        locationName: location.name,
        locationId: location.id,
        patientPhone: contact.cellPhone
      });
    } else {
      goToProduct();
      onClick && onClick();
    }
  };

  const goToProduct = useCallback(() => {
    if (hasProduct('messenger')) {
      publish({
        messageType: 'jumpToMessage',
        data: {
          patientId: contact.id
        } as EventJumpToMessage['data']
      });
    } else {
      publish({
        messageType: 'messengerWidget',
        data: {
          phoneNumber: contact.cellPhone,
          locationId: contact.location?.id
        } as EventMessengerWidget['data']
      });
    }
  }, [hasProduct, publish, contact]);

  const handleLocationSwitch = async (data: LocationSwitchEventData) => {
    setLocationSwitchEvent(null);
    await switchLocation(data.locationId);
    goToProduct();
    onClick && onClick();
  };

  if (contact && isCellPhoneValid() && (hasProduct('messenger') || hasProduct('messenger2')))
    return (
      <>
        <IconButtonStyled onClick={handleMessengerClick} size="large" sx={{ marginLeft: '10px' }}>
          <ForumIcon color="primary" />
        </IconButtonStyled>
        {locationSwitchEvent && (
          <SwitchLocationDialog
            eventData={locationSwitchEvent}
            message="This patient is in another location. Would you like to switch locations and go to messages?"
            onSwitchLocation={handleLocationSwitch}
            onClose={() => setLocationSwitchEvent(null)}
          />
        )}
      </>
    );
  else return null;
};
